import React, { useRef } from "react";
import { Layout, Row, Col } from "antd";
import { motion } from "framer-motion";
import HeaderSearch from "./HeaderSearch";
import HeaderUser from "./HeaderUser";
import MenuLogo from "../menu/logo";

const { Header } = Layout;

export default function MenuHeader() {
  const inputFocusRef = useRef(null);

  return (
    <Header className="oekfb-admin-header">
      <motion.div initial={{ opacity: 0, y: -16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.25 }} className="hp-w-100 oekfb-admin-header__motion">
        <Row className="oekfb-admin-header__row" align="middle" wrap={false}>
          <Col flex="none" className="oekfb-admin-header__brand">
            <MenuLogo to="/admin" />
          </Col>
          <Col flex="auto" className="hp-header-search oekfb-admin-header__search">
            <HeaderSearch inputFocusProp={{ ref: inputFocusRef }} setSearchHeader={() => {}} />
          </Col>
          {/* Language, notifications and template profile controls are intentionally hidden for now. */}
          <Col flex="none" className="oekfb-admin-header__user"><HeaderUser /></Col>
        </Row>
      </motion.div>
    </Header>
  );
}
